// window.addEventListener("load", () => {
//     const wishlistCartBtn = document.querySelector(".hulk-custom-move-to-wishlist-icon");
//     if (wishlistCartBtn && window.HulkappWishlist?._saveForLater) {
//         wishlistCartBtn.addEventListener("click", () => {
//             document.querySelectorAll(".drawer__cart-items-wrapper > .addtoWishlist").forEach(btn => {
//                 btn.click();
//             });
//         });
//     }

//     const polling = setInterval(() => {
//         const btn = document.querySelector(".grid-wishlist-btn");

//         if (btn && window.HulkappWishlist?.init) {
//             clearInterval(polling);

//             // window.HulkappWishlist.init();
//         }
//     }, 100);
// });

document.addEventListener("click", e => {
    const variantContainer = e.target.closest("product-swatches");
    if (variantContainer) {
        const btns = document.querySelectorAll(".wishlist-btn");

        setTimeout(() => {
            window.HulkappWishlist?._checkForProductStatus(Array.from(btns), "multiple");
        }, 200);
    }
}, true);